import { render, staticRenderFns } from "./Constantes.vue?vue&type=template&id=a38bf5c8&scoped=true"
import script from "./Constantes.vue?vue&type=script&lang=js"
export * from "./Constantes.vue?vue&type=script&lang=js"
import style0 from "./Constantes.vue?vue&type=style&index=0&id=a38bf5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38bf5c8",
  null
  
)

export default component.exports